/**
 * Created by tendlich on 04/03/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var LEResourceResolver = require("leResourceResolver");
    var LEConfig = require("assets/config/le-env-conf");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    var AuthenticationModel = {};
    var logger = LE.logger;

    LE.module("LEContent", function () {

        AuthenticationModel = BaseModel.extend({
            name: "JwtModel",

            resource: function () {
                LE.urlResolver.addConfigValue("monitoredAccountId", LE.LPtag_mtaconfig.siteId);
                if (this._isIDPRequest()) {
                    var idpDomain = "va-a.idp.liveperson.net";
                    if (window.lpTag && window.lpTag.csds) {
                        idpDomain = window.lpTag.csds.getDomain("idp");
                    }
                    var tag_idp = {
                        "endpoint": {
                            "transport": "postmessage",
                            "configuration": {
                                "url": "{lptag_idp}/postmessage/postmessage.min.html",
                                "delayLoad": 0,
                                "maxReloadRetries": 480,
                                "reloadInterval": 30
                            }
                        },
                        "getLPJWT": {
                            "url": "{lptag_idp}/api/account/{monitoredAccountId}/authenticate"
                        }
                    };
                    LE.urlResolver.addConfigValue('lptag_idp', idpDomain);
                    LEResourceResolver.addLocalApiResource('TAG_IDP', tag_idp);
                    return {"url": LEResourceResolver.getUrl(ApiResources.TAG_IDP.getLPJWT)};
                }
                return ApiResources.ConnectionPanel.Token;
            },

            fetch: function (options) {
                var data = this._createPayload();
                _.extend(options, {
                    data: data,
                    contentType: 'application/json',
                    type: 'POST'
                });
                if (!this._isIDPRequest() && (!options.retryCount || options.retryCount < 2 )) {
                    // wrap the request error function with a retry call
                    var originalErrorFunc = options.error;
                    options.error = _.bind(function () {
                        logger.error('Could not load JWT from CP Backend, retrying...', 'AuthenticationModel.fetch');
                        options.retryCount = options.retryCount !== undefined ? options.retryCount + 1 : 1;
                        var timeoutInterval = options.retryCount * options.retryCount * 1000;
                        options.error = originalErrorFunc;

                        setTimeout(_.bind(function () {
                            return this.fetch.call(this, options);
                        }, this), timeoutInterval);

                    }, this);
                }
                return BaseModel.prototype.fetch.call(this, options);
            },

            parse: function (resp) {
                if (resp.token) {
                    resp.jwt = resp.token;
                    resp.token = null;
                }
                return resp;
            },

            getSkillName: function () {
                return this.get('skillName');
            },

            getJWT: function () {
                return this.get('jwt');
            },

            _createPayload: function () {
                var payload;
                if (this._isIDPRequest()) {
                    payload = {
                        authCode: this.get("jwt")
                    };
                } else {
                    payload = {
                        "lp_sdes": this._getSDEs(),
                        "audienceId": lpTag.site
                    };

                    if (!this.get('isPSGContact')) {
                        payload.skill = this.get('skillName');
                    }
                }
                return payload;
            },

            _getSDEs: function () {

                return [{
                    type: "ctmrinfo",
                    info: {
                        ctype: this.getSkillName(),
                        customerId: LE.sessionManager.getUserId(),
                        accountName: LE.context.App.loginInfo.accountId
                    }
                }];
            },

            _isIDPRequest: function () {
                return this.has('jwt');
            }
        });
    });
    return AuthenticationModel;
});
